import React from "react";
import LegalShell from "../../components/root/LegalShell";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";

export default function RefundCancellationPolicy() {
  return (
    <LegalShell title="Delivery, Refund, Return &amp; Cancellation Policy" updated="July 27, 2026">
      <Seo
        {...SEO["/refund-policy"]}
        path="/refund-policy"
      />

      <p>
        This policy applies to all paid products offered by Cabil Educational Services
        ("Cabil"), including mentorship sessions booked through the Cabil platform and
        Cabil Kids subscription plans. It explains what to expect around delivery,
        cancellations, and refunds when you pay for any Cabil service.
      </p>

      <h2>Delivery</h2>
      <p>
        Cabil is a digital service — no physical goods are shipped. Access to a purchased
        service (a booked mentorship session, or a Cabil Kids subscription plan) is granted
        electronically, immediately after payment is confirmed, through your Cabil account.
        There is no shipping, courier, or physical delivery involved in any Cabil purchase.
      </p>

      <h2>Cancellations</h2>
      <ul>
        <li>
          <strong>Mentorship sessions:</strong> A booked session may be cancelled or
          rescheduled up to 24 hours before the scheduled start time at no charge, from your
          dashboard or by contacting us. Cancellations made less than 24 hours before a
          session may not be eligible for a refund, at the discretion of Cabil and the
          mentor involved.
        </li>
        <li>
          <strong>Cabil Kids subscriptions:</strong> You may cancel a subscription at any
          time from Settings. Cancelling stops future billing; it does not automatically
          refund the current billing period. Cabil Kids also offers a 14-day free trial with
          no charge and no card required, so you can evaluate the product before any payment
          is made.
        </li>
      </ul>

      <h2>Refunds</h2>
      <p>
        Refund requests are reviewed on a case-by-case basis and are generally granted when:
      </p>
      <ul>
        <li>A payment was charged in error or duplicated by the payment gateway.</li>
        <li>A booked mentorship session did not take place due to a fault on Cabil's or the mentor's side.</li>
        <li>A technical issue on Cabil's platform prevented you from accessing a service you paid for, and the issue could not be resolved within a reasonable time.</li>
      </ul>
      <p>
        Approved refunds are issued to the original payment method within 7–10 business days,
        subject to processing times of the payment gateway and issuing bank. Partial billing
        periods for cancelled subscriptions are not refunded except where required by law.
      </p>

      <h2>Returns</h2>
      <p>
        As Cabil sells digital services rather than physical products, there are no items to
        return. Any dispute about service quality should be raised through the refund process
        above.
      </p>

      <h2>How to request a cancellation or refund</h2>
      <p>
        Contact us at <a href="mailto:info@cabil.co">info@cabil.co</a>, on{" "}
        <a href="https://wa.me/+923314622245" target="_blank" rel="noreferrer">WhatsApp</a>, or
        through the <a href="/contact-us">Contact page</a>, with your account email and the
        payment/booking you're asking about. We aim to respond to all cancellation and refund
        requests within 2 business days.
      </p>

      <h2>Contact</h2>
      <p>
        Cabil Educational Services — Office 404, Al-Fiza Glass Tower, Block 10-A, Rashid
        Minhas Road, Karachi, Pakistan · C-17, Sector 14-A, North Nazimabad Town, Karachi,
        Pakistan. Email <a href="mailto:info@cabil.co">info@cabil.co</a>, phone{" "}
        <a href="tel:+923314622245">+92 331 4622245</a>.
      </p>
    </LegalShell>
  );
}
